export const VARIANT_COLOURS: Record<StoryblokDatatypeVariantColours, string> =
  {
    'black': '#000000',
    'brown': '#5b4424',
    'dark-blue': '#000080',
    'dark-green': '#057b4f',
    'gold': '#ae8a1a',
    'grey': '#6d6b69',
    'light-blue': '#74D0FF',
    'light-green': '#75c794',
    'orange': '#ff5207',
    'pink': '#f15597',
    'purple': '#7a54c9',
    'red': '#cb2e2e',
    'white': '#FFFFFF',
    'yellow': '#FCD445',
  };

export const VARIANT_SIZES_SORT_ORDER: Record<
  StoryblokDatatypeVariantSizes,
  number
> = {
  xs: 1,
  s: 2,
  m: 3,
  l: 4,
  xl: 5,
};
